import {NbMenuService} from '@nebular/theme';
import { HappyMammaService } from '../../@core/data/happymamma.service';
import { BASE_PATH_MOODLE } from '../../../environments/configs';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'ngx-moodle-auth',
    templateUrl: './moodle-auth.component.html',
    styleUrls: ['./moodle-auth.component.scss'],
})
export class MoodleAuthComponent implements OnInit {

    constructor(
        private hmService: HappyMammaService,
        private menuService: NbMenuService,
        private router: Router,

    ) {
    }


    async ngOnInit() {
        this.openMoodle();
        this.goHome();
    }


    async goHome() {
        this.router.navigate(['']);
  }



    async openMoodle() {
        const otp = await this.hmService.getOtp().toPromise();
        const url = BASE_PATH_MOODLE + '/login/index.php?otp=' + otp;
        window.open(url, '_blank');
    }



}
